// Template260: Bélgica - Gastronomía (Shops.jsx)
// Header, list of sections from data.sections (title, body, list, highlight), optional sabiasQue per section (componente SabiasQue como Template257), sticker on last block.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template260 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";

	const headerText = page?.texts?.[0]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const stickerImage = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const actualHeaderColor = headerBackgroundColor || "#D4A017";
	const sections = Array.isArray(page?.sections)
		? page.sections
		: Array.isArray(page?.data?.sections)
			? page.data.sections
			: Array.isArray(page?.data?.data?.sections)
				? page.data.data.sections
				: [];

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "8px",
		marginTop: 0,
		color: "#8b6914",
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 99999,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "0 16px",
					display: "flex",
					flexDirection: "column",
					gap: 2,
					marginTop: 1.5,
					position: "relative",
				}}
			>
				{sections.map((sec, idx) => (
					<Box
						key={idx}
						data-block-id={`text-${idx + 2}`}
						sx={{
							backgroundColor: sec.highlight ? "#f9ebc8" : "#fff",
							borderRadius: "12px",
							padding: "14px 16px",
							border: sec.highlight ? "2px solid #D4A017" : "2px solid #f0e6c8",
							position: "relative",
						}}
					>
						{sec.title && (
							<Box component="h3" sx={estiloH3}>
								{sec.title}
							</Box>
						)}
						{sec.body && (
							<Box
								component="div"
								sx={estiloP}
								dangerouslySetInnerHTML={{ __html: sec.body }}
							/>
						)}
						{sec.list && (
							<Box
								component="ul"
								sx={{ paddingLeft: "18px", margin: "8px 0 0 0", fontSize: 13 }}
								dangerouslySetInnerHTML={{ __html: sec.list }}
							/>
						)}
						{sec.sabiasQue && (
							<Box sx={{ position: "absolute", top: -20, right: "50%" }}>
								<SabiasQue
									icono={sec.sabiasQue.icono}
									texto={sec.sabiasQue.texto}
								/>
							</Box>
						)}
						{sec.highlight && stickerImage && (
							<Box
								component="img"
								src={stickerImage}
								alt=""
								sx={{
									width: isSmallScreen ? 100 : 100,
									position: "absolute",
									bottom: isSmallScreen ? -90 : 0,
									right: -20,
								}}
							/>
						)}
					</Box>
				))}
			</Box>
		</Box>
	);
};

Template260.thumbnail = "/images/template-1.png";
export default Template260;
